import React, { useEffect, useState } from "react";
import api from "../../api";

export default function AdminUploads() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/uploads").then((r) => setList(r.data)); }, []);

  return (
    <div data-testid="admin-uploads-screen">
      <h1 className="font-display text-4xl mb-2">Upload audit</h1>
      <p className="text-muted-foreground mb-8">Every Excel upload, who uploaded it, when, and what happened.</p>

      <div className="card-soft overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead className="bg-[hsl(var(--neu-paper))] text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left p-3">File</th>
              <th className="text-left p-3">Kind</th>
              <th className="text-right p-3">Rows</th>
              <th className="text-right p-3">Validated</th>
              <th className="text-right p-3">Errors</th>
              <th className="text-left p-3">Status</th>
              <th className="text-left p-3">When</th>
            </tr>
          </thead>
          <tbody>
            {list.map((u) => (
              <tr key={u.id} className="border-t">
                <td className="p-3">{u.file_name}</td>
                <td className="p-3">{u.kind}</td>
                <td className="p-3 text-right">{u.row_count}</td>
                <td className="p-3 text-right">{u.validated_rows}</td>
                <td className="p-3 text-right">{u.errors?.length || 0}</td>
                <td className="p-3"><span className="chip">{u.status}</span></td>
                <td className="p-3 text-muted-foreground">{new Date(u.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-muted-foreground">No uploads yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
